import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/index";
import store from "../store/index";
import "./plugins/base";
import {
  API,
  LOCATION_API,
  REPORTS,
  DEV,
  DRS_API,
  PDS_API,
  PAYMENT_API,
  ERROR_SERVICE_API
} from "../http-common";
import VueApexCharts from "vue-apexcharts";
import DatetimePicker from "vuetify-datetime-picker";
import VueConfetti from "vue-confetti";
import VueTheMask from "vue-the-mask";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import JsonCSV from "vue-json-csv";
import JsonExcel from "vue-json-excel";
import VuePapaParse from "vue-papa-parse";
import VuetifyMoney from "vuetify-money";
Vue.use(VuetifyMoney);
Vue.use(VuePapaParse);
Vue.use(VueViewer, {
  defaultOptions: {
    button: true,
    navbar: false,
    title: false,
    toolbar: true,
    tooltip: false,
    rotatable: false,
    scalable: false,
    fullscreen: true,
    keyboard: true,
  },
});

Vue.use(VueConfetti);
Vue.use(DatetimePicker);
Vue.use(VueTheMask, { masked: false });

//Use the window object to make it available globally.
Vue.use({
  install(Vue) {
    Vue.prototype.$api = API;
    Vue.prototype.$location = LOCATION_API; // for location service
    Vue.prototype.$reports = REPORTS;
    Vue.prototype.$dev = DEV;
    Vue.prototype.$drs = DRS_API;
    Vue.prototype.$pds = PDS_API;
    Vue.prototype.$payment = PAYMENT_API;
    Vue.prototype.$errService = ERROR_SERVICE_API;
    

    Vue.prototype.$api.interceptors.request.use(
      (config) => {
        let token = store.getters.token;
        if (token) {
          config.headers = Object.assign(
            {
              "wsc-token": token,
            },
            config.headers
          );
        }
        return config;
      },
      (error) => {
        console.log(error);
        return Promise.reject(error);
      }
    );

    Vue.prototype.$drs.interceptors.request.use(
      (config) => {
        let token = store.getters.token;
        if (token) {
          config.headers = Object.assign(
            {
              // "wsc-token": token,
              Authorization: token,
            },
            config.headers
          );
        }
        return config;
      },
      (error) => {
        console.log(error);
        return Promise.reject(error);
      }
    );

    Vue.prototype.$reports.interceptors.request.use(
      (config) => {
        let token = store.getters.token;
        if (token) {
          config.headers = Object.assign(
            {
              "wsc-token": token,
            },
            config.headers
          );
        }
        return config;
      },
      (error) => {
        console.log(error);
        return Promise.reject(error);
      }
    );

    Vue.prototype.$verifier = "sp.verifier";
    Vue.prototype.$dd_verifier = "dd.verifier";

    // check if session expired
    Vue.prototype.$drs.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        const originalRequest = error.config;
        console.log(originalRequest);
        console.log(error.response);
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          alert("Session expired.");
          store.commit("logout");
          router.push("/login");
          return;
        }

        return Promise.reject(error);
      }
    );
  },
});
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.component("downloadCsv", JsonCSV);
Vue.component("downloadExcel", JsonExcel);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
